import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSalTableDialerByAfid } from 'actions'
import {isEmpty} from 'lodash'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CustomAvatar from "../Avatar/index";
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard}) {
    const { authUser} = auth;
    const { SalTabel,DashboardDialerFilterOption} = DashBoard;
    return {
        authUser,SalTabel,DashboardDialerFilterOption
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getSalTableDialerByAfid: (Afid,userid,FilterOption) => dispatch(getSalTableDialerByAfid(Afid,userid,FilterOption)),
        dispatch
    }
}
const useStyles = theme => ({
    root: {
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '3px'
          },
           
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          },
           
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12484B',
            outline: '1px solid transparent'
          }
     },
  });
const StyledTableCell = withStyles((theme) => ({
    head: {
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);
class CustomizedTables extends Component {
    state={
        SalTabel:0,
        DashboardDialerFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getSalTableDialerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })        
    }
    
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getSalTableDialerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            30000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    formatNumber=(number)=>{
        console.log(number)
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    componentDidUpdate=()=>{
      /*  if(this.props.DashboardDialerFilterOption !== this.state.DashboardDialerFilterOption && !isEmpty(this.props.DashboardDialerFilterOption))
           {
                
               const Afid = this.props.Afid;
               this.props.getSalTableDialerByAfid(Afid).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) 
               this.setState({
                DashboardDialerFilterOption:this.props.DashboardDialerFilterOption 
               }) 
           }*/
        }
    render() {
        console.log('test565445', this.props.SalTabel)
        const { classes } = this.props;
        return (
            <> {
                this.state.done === false?
                <div className="row mx-1 w-100">
                <div className="col-12 row mx-1">
                    <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                </div>
                <div className="col-12 row mx-1">
                    <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                </div>
                <div className="col-12 row mx-1">
                    <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                </div>
            </div>
                :
             <TableContainer className={classes.root} style={{overflowY: "auto",height: this.props.DSMaxHeight}}>
                <Table aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="user.Role.User" />:</StyledTableCell>
                        {/* <StyledTableCell style={{ borderBottom: '1px solid #44D1C2' }}></StyledTableCell> */}
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Rings"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.NoAnswer"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.period"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Return.Personal.Short"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Return.Global.Short"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.No.Thanks"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Loss"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Booking"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Accepted.Meeting.Short"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Quality"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Hitrate"/>:</StyledTableCell>
                        <StyledTableCell align="right" style={{ color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2', padding: '8px 16px' }}><IntlMessages id="Table.Activing"/>:</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        isEmpty(this.props.SalTabel)?"":
                        this.props.SalTabel.map(item=>{
                            // console.log('test12345678',item)
                            return (
                            <StyledTableRow key={item.userid}>
                                {/* <StyledTableCell component="th" scope="row" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', width: '50px', borderBottom: '1px solid #44D1C2' }}>
                                    <CustomAvatar />
                                </StyledTableCell> */}
                                <StyledTableCell align="left" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            isEmpty(item.ProfilePicUrl) ? 
                                            <CustomAvatar />
                                            :
                                            <div 
                                                style={{
                                                    height: '30px',
                                                    width: '30px',
                                                    borderRadius: '50%',
                                                    backgroundImage: 'url('+item.ProfilePicUrl+')',
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    border: '1px solid #fff'
                                                }}
                                            ></div>
                                        }
                                        
                                        <span style={{ marginLeft: '1rem' }}> 
                                            {`${item.FirstName} ${isEmpty(item.LastName)?"":item.LastName}`} 
                                            <small>{parseInt(item.OfficeId)!==0?`( ${item.stad} )`:""}</small>
                                        </span>
                                    </div>
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.Samtal} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.EjSvar} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.Avtalstid} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.AterPer} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.AterGlo} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.NejTack} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.BortFall} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.BokaMote} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.Gmoten} st
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.Kvalit.toFixed(0)}%
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.Hitrate.toFixed(0)}%
                                </StyledTableCell>
                                <StyledTableCell align="right" style={{ paddingTop: '10px', paddingBottom: '10px', color: 'white', fontSize:this.props.DsfontSize, borderBottom: '1px solid #44D1C2' }}>
                                    {item.Aktiverade} st
                                </StyledTableCell>
                            </StyledTableRow>
                            )
                            
                        })
                    }
                </TableBody>
                </Table>
             </TableContainer>
    }
            </>
        ) 
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
  )(withStyles(useStyles)(CustomizedTables));
//